import $ from '@republic/spellcaster';
export default [$.url('webview:cancel', {})];